import { ApiHttpService } from '../ApiHttpService';
import { VideoSerializer } from '../serializers/VideoSerializer';
import { Video } from '../../models/Video';

const PRODUCT_VIDEOS_PATH = 'articulos/videos/';

class VideosController {
  static async all(id) {
    const response = await ApiHttpService.get(`${PRODUCT_VIDEOS_PATH}${id}`);
    const deSerializedData = response.data.map(VideoSerializer.deSerialize);
    return deSerializedData.map(data => new Video(data));
  }
}

export { VideosController };



// WEBPACK FOOTER //
// ./src/networking/controllers/VideosController.js